import React from 'react'
import Modal from 'react-responsive-modal';
import {Flex} from '/app/src/component'
import style from './style.css'

export default class JibberModal extends React.Component {
    render() {
       return(
       <Modal
        styles={{modal: {padding: '0px', background: 'none', boxShadow: 'none'}}}
        showCloseIcon={true}
        center
        open={true}>
        <Flex className={style.ModalWrapper} column>
            <Flex center className={style.Header}> {this.props.title}</Flex>
            <Flex grow className={style.Body}> {this.props.children}</Flex>
        </Flex>
       </Modal>
       )
    }
}



// WEBPACK FOOTER //
// src/component/Modal/Modal.js